import useSWR from 'swr';
import type { PropertyDealWithPrices } from '~/models/PropertyDeal';
import type { SwrReturnType } from '~/models/Api';

const buildShowPath = (id: number): string => `/property_deals/${id}`;
// global mutateで使用するキー
export const propertyDealCacheKey = (id: number): string => buildShowPath(id);

export const usePropertyDeal = (
  id: number
): SwrReturnType<PropertyDealWithPrices> => {
  const swrKey = buildShowPath(id);
  const { data, mutate, error, isLoading } =
    useSWR<PropertyDealWithPrices>(swrKey);

  const loading =
    id === null ? false : isLoading ?? (data === undefined && !error);

  return {
    data: data ?? null,
    mutate,
    isLoading: loading,
    error
  };
};
